// extracted by mini-css-extract-plugin
module.exports =  {"info":"_2787e5dfdf--info--If36j","info__group":"_2787e5dfdf--info__group--TJ5KS","type":"_2787e5dfdf--type--yfTaA"};